import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(phone, password);
      navigate("/panel");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="login-page"
      className="flex min-h-screen flex-col bg-[#FDFBF7]"
    >
      <header className="border-b-2 border-[#1A1A1A]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-8">
          <Link to="/" data-testid="login-logo-link">
            <img
              src="/assets/logo.png"
              alt="Deny's Burger & Fries logosu"
              className="h-12 w-auto"
            />
          </Link>
          <Link
            to="/"
            data-testid="login-back-link"
            className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            <ArrowLeft size={16} strokeWidth={2.5} /> Ana Sayfa
          </Link>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="card-print w-full max-w-md p-8 md:p-10">
          <p className="font-script text-2xl text-[#E63946]">Şube Paneli</p>
          <h1 className="mt-2 text-3xl font-black uppercase tracking-tighter text-[#1A1A1A]">
            Restoran Girişi
          </h1>
          <p className="mt-3 text-sm font-medium text-[#4A4A4A]">
            Quick Order sistemi için şube hesabınızla giriş yapın.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div>
              <label
                htmlFor="login-phone"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Telefon
              </label>
              <input
                id="login-phone"
                data-testid="login-phone-input"
                type="tel"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="mt-2 w-full border-2 border-[#1A1A1A] bg-white px-4 py-3 text-sm font-medium text-[#1A1A1A] outline-none focus:shadow-[3px_3px_0_0_#E63946]"
                placeholder="532 322 21 30"
              />
            </div>
            <div>
              <label
                htmlFor="login-password"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Şifre
              </label>
              <input
                id="login-password"
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border-2 border-[#1A1A1A] bg-white px-4 py-3 text-sm font-medium text-[#1A1A1A] outline-none focus:shadow-[3px_3px_0_0_#E63946]"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div
                data-testid="login-error-message"
                className="border-2 border-[#E63946] bg-[#E63946]/10 px-4 py-3 text-sm font-bold text-[#E63946]"
              >
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="btn-chunky w-full justify-center bg-[#E63946] px-6 py-3 text-base uppercase tracking-wide text-white disabled:opacity-60"
            >
              <LogIn size={20} strokeWidth={2.5} />
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
